import { Box, Grid, Stack, Typography } from '@mui/material';
import InfoTooltip from './InfoTooltip';
import { useBoundStore } from 'useStore';
import ShortLargeValues from './ShortLargeValues';
import useForecastData from '../../Queries/forecastQuery';

export default function MainColumnHeader() {
	const selectedYear = useBoundStore((state) => state.forecastSelectedYear);
	const forecastQuery = useForecastData();
	const yearData = forecastQuery?.data?.yearCardInfo;

	return (
		<Box
			sx={{
				padding: '24px 16px',
				borderTop: '1px solid #35488740',
				borderBottom: '1px solid #35488740',
				borderRight: '1px solid #35488740',

				fontSize: '1.5rem',
				height: '164px',
				width: '420px',

				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
			}}
		>
			<Stack>
				<Typography
					sx={{
						color: '#36498A',
						fontWeight: 500,
					}}
				>
					Forecast
				</Typography>
				<Typography
					sx={{
						color: '#36498A',
						fontWeight: 600,
						fontSize: '36px',
						fontFamily: 'Montserrat',
						lineHeight: '24px',
						letterSpacing: '0.17px',
					}}
				>
					{selectedYear}
				</Typography>
			</Stack>

			<Grid container>
				<Grid item xs={6}>
					<Stack direction="row" alignItems="center" spacing="2px">
						<Typography
							sx={{
								color: '#00000061',
								fontWeight: 600,
								fontFamily: 'Roboto',
								fontSize: '12px',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							GMV USD Anual
						</Typography>
						<InfoTooltip title="GMV USD Anual Total" />
					</Stack>
				</Grid>
				<Grid item xs={6}>
					<Typography
						sx={{
							color: '#000000DE',
							fontWeight: 600,
							fontFamily: 'Roboto',
							fontSize: '12px',
							lineHeight: '24px',
							letterSpacing: '0.15px',
						}}
					>
						USD{' '}
						<ShortLargeValues
							value={yearData?.gmv_sum_usd_yearly}
							field="gmv_usd"
						/>
					</Typography>
				</Grid>

				<Grid item xs={6}>
					<Stack direction="row" alignItems="center" spacing="2px">
						<Typography
							sx={{
								color: '#00000061',
								fontWeight: 600,
								fontFamily: 'Roboto',
								fontSize: '12px',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							GMV Local Anual
						</Typography>
						<InfoTooltip title="GMV Local Anual Total" />
					</Stack>
				</Grid>
				<Grid item xs={6}>
					<Typography
						sx={{
							color: '#000000DE',
							fontWeight: 600,
							fontFamily: 'Roboto',
							fontSize: '12px',
							lineHeight: '24px',
							letterSpacing: '0.15px',
						}}
					>
						$
						<ShortLargeValues
							value={yearData?.gmv_sum_loc_yearly}
							field="gmv_local"
						/>
					</Typography>
				</Grid>
			</Grid>
		</Box>
	);
}
